import React from "react";

const Card = ({title, description, image, onClick}) => {
    return(
        <div style={{backgroundColor:`#FFFFFF`}} className={`p-2 w-[100%] bg-[#FFFFFF] rounded-2xl overflow-hidden flex justify-between lg:flex-row xs:flex-row-reverse flex-col-reverse xs:gap-2 gap-0`}>
            <div className="xs:p-4 xs:w-[50%] xs:h-[100%] h-fit flex flex-col justify-start">
                <h1 className={`lg:text-[32px] xs:text-[28px] text-[24px] lg: mb-4 xs:mb-4 lg:mb-6 xs:mt-0 mt-2 text-[#1F2225]`}>{title}</h1>
                <span className={`xs:text-[16px] text-[14px] text-[#353A40] xs:mb-12`}>{description}</span>
                <button
                onClick={onClick}
                className={`group xs:mt-auto mt-4 mr-auto mb-2 xs:mb-0 transition duration-300 bg-none  text-[#1F2225] hover:bg-[#353A40] hover:text-[#FFF] border-[#1F2225] border-[1px] rounded-full px-5 py-2.5 text-[16px] flex items-center justify-between gap-2
                 active:bg-[#1F2225]`}>
                    <span>Перейти</span>
                    <img src="Union.svg" alt="icon" className="transition duration-300 group-hover:invert"/>
                </button>
            </div>
            <div className="xs:w-[50%] xs:h-[100%] h-fit ">
                <img src={image} alt={title} className="h-full w-full object-cover rounded-xl aspect-[1/1] xs:aspect-auto lg:aspect-square"/>
            </div>
        </div>
    );
};

export default Card;